export const assetTypeFacetKey = 'asset_type';
